import { render } from "./MonthlyClosureWizard.vue?vue&type=template&id=46e29b57&scoped=true"
import script from "./MonthlyClosureWizard.vue?vue&type=script&lang=js"
export * from "./MonthlyClosureWizard.vue?vue&type=script&lang=js"

import "./MonthlyClosureWizard.vue?vue&type=style&index=0&id=46e29b57&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-46e29b57"

export default script